<script setup lang="ts">
import ICON1 from '~/assets/images/user/vip/success.svg'
import ICON2 from '~/assets/images/user/vip/error.svg'

defineProps<{
  type: number
  data: any
}>()
const emit = defineEmits(['cancel'])
const { userRole } = useLogin()
const { userCorporateMember } = usePay()
</script>

<template>
  <div px-32 py-24>
    <div class="relative w-full flex justify-center gap-8 pb-16 text-center text-16 text-[--color-text-1] font-500">
      <img :src="type === 1 ? ICON1 : ICON2" alt="" w-16>
      {{ $t('支付成功') }}
      <span class="absolute right--8 top--8 h-20 w-20 flex cursor-pointer items-center justify-center text-18 text-[--color-text-1] hover:op-80" @click="emit('cancel')"><i class="icon-shanchu" /></span>
    </div>
    <div class="mb-24px text-center text-14 text-[--color-text-1]">
      <span v-if="type === 1">
        <span v-if="data?.resource === 6" v-html="$t('vip.payModal1', [`<span class='mx-4 font-600'>${userCorporateMember?.totalUserRelationCount}</span>`])" />
        <template v-else>
          <span v-html="$t(`${userRole?.resource === data?.resource ? 'vip.payModal3' : 'vip.payModal2'}`, [`<span mx-4 font-600>${$t(data?.resourceName)}</span>`])" />
          <span v-if="userRole?.resource === 2 && data?.resource === 1">
            {{ $t('，剩余专业版会员时长已折算成企业版会员') }}
          </span>
        </template>
      </span>
      <span v-else>
        {{ $t('支付失败，请重新支付') }}
      </span>
    </div>
    <div mt-24 text-center>
      <a-button type="primary" shape="round" size="small" class="w-98" @click="emit('cancel')">
        {{ $t('我知道了') }}
      </a-button>
    </div>
  </div>
</template>

<style lang="less">

</style>
